// 保証会社
const WarrantyCompany = {
  namespaced: true,

  state: {
    modal: false,
    waranty: [], // 保証会社
    listPageStatus: {
      from: null,
      to: null,
      total: null,
      current_page: null,
    },
    formItem: {
      id: null,
      name_surety: '',
      waranty_fee1: null,
      sel_waranty_fee1_unit: null,
      tax_waranty_fee1: null,
      waranty_fee2: null,
      sel_waranty_fee2_unit: null,
      tax_waranty_fee2: null,
      waranty_fee3: null,
      sel_waranty_fee3_unit: null,
      tax_waranty_fee3: null,
      fee_surety: '',
      guarantor_memo: '',
    },
  },
  getters: {
    getModal: state => {
      return state.modal
    },
    getWarranty: state => {
      return state.waranty
    },
    getListPageStatus: state => {
      return state.listPageStatus
    },
    getFormItem: state => {
      return state.formItem
    },
  },
  mutations: {
    setModal(state, modal) {
      state.modal = modal
    },
    setWarranty(state, list) {
      state.waranty = list
    },
    setListPageStatus(state, status) {
      state.listPageStatus = status
    },
    setFormItem(state, item) {
      state.formItem = item
    },
  },
  actions: {
    resetFormItem({ commit }) {
      let resetData = {
        id: null,
        name_surety: '',
        waranty_fee1: null,
        sel_waranty_fee1_unit: null,
        tax_waranty_fee1: null,
        waranty_fee2: null,
        sel_waranty_fee2_unit: null,
        tax_waranty_fee2: null,
        waranty_fee3: null,
        sel_waranty_fee3_unit: null,
        tax_waranty_fee3: null,
        fee_surety: '',
        guarantor_memo: '',
      }
      commit('setFormItem', resetData)
    },
  },
}

export default WarrantyCompany
